import { render } from "./FavoritesFormDialog.vue?vue&type=template&id=399a05ac&ts=true"
import script from "./FavoritesFormDialog.vue?vue&type=script&lang=ts"
export * from "./FavoritesFormDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__